import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import {
  BlkOrderActionTypes,
  BlkOrderActions,
} from '@ordersnproducts/modules/order-builder/modules/multiple-order-summary/actions/order.actions';
import { OrderLoad, OrderSummary } from '../models/orderSummary.model';
import {
  LocationSpecificationActions,
  LocationSpecificationActionTypes,
} from '../../location-specification/actions/location-specifications.actions';

export interface BlkOrderState {
  loading: boolean;
  orders: BlkOrders[];
}

export interface BlkOrders {
  formId: number;
  order: OrderSummary;
  items: OrderLoad[];
}

export const initialState: BlkOrderState = {
  loading: false,
  orders: [],
};

export function orderReducer(
  state = initialState,
  action: BlkOrderActions | OrderBuilderActions | LocationSpecificationActions,
): BlkOrderState {
  switch (action.type) {
    case RESET_BUILDER:
    case BlkOrderActionTypes.RESET: {
      return {
        loading: false,
        orders: [],
      };
    }
    case BlkOrderActionTypes.REQUEST: {
      return {
        ...state,
      } as BlkOrderState;
    }
    case BlkOrderActionTypes.REQUEST_COMPLETE: {
      const order = state.orders.find(x => x.formId === action.payload.formId);
      if (order) {
        order.order = action.payload.order;
        order.items = action.payload.items;
      } else {
        state.orders.push(action.payload);
      }
      return {
        ...state,
        loading: false,
      } as BlkOrderState;
    }
    case LocationSpecificationActionTypes.REMOVE_ITEM: {
      return {
        ...state,
        orders: state.orders.filter(i => i.formId !== action.payload),
      };
    }
    case BlkOrderActionTypes.START_LOADING: {
      return {
        ...state,
        loading: true,
      } as BlkOrderState;
    }
    case BlkOrderActionTypes.LOADING_COMPLETE: {
      return {
        ...state,
        loading: true,
      } as BlkOrderState;
    }
    default: {
      return state;
    }
  }
}
